import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Link } from "react-router-dom";
import "../../assets/css/topbar.css";

function Topbar() {
  const { logout } = useContext(AuthContext);
  const [user, setUser] = useState({ nom: "", prenom: "" });

  const logo = require('../../assets/images/logo/logo.png');
  const urlProfile = process.env.REACT_APP_API_URL_PROFILE;
  const defaultProfile = `${urlProfile}/default.png`;

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (userData) {
      setUser({ nom: userData.nom, prenom: userData.prenom, photo: userData.photo });
    }
  }, []);

  return (
    <nav className="navbar topbar sticky-top shadow-sm">
      <div className="container-fluid px-3 px-md-4">
        {/* Toggle sidebar — géré nativement par Bootstrap offcanvas, plus de JS manuel */}
        <button
          type="button"
          className="btn btn-link text-dark p-2 me-2 d-lg-none"
          data-bs-toggle="offcanvas"
          data-bs-target="#sidebar"
          aria-controls="sidebar"
          aria-label="Afficher / masquer le menu"
        >
          <i className="fa fa-bars fs-5"></i>
        </button>

        <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
          <img src={logo} alt="SpyTeam" height="30" />
          <span className="fw-bold d-none d-sm-inline">SpyTeam</span>
          <span className="topbar-live" aria-hidden="true"></span>
        </Link>

        <div className="ms-auto dropdown">
          <button
            className="btn btn-light d-flex align-items-center gap-2 rounded-pill border"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              className="topbar-avatar rounded-circle"
              src={user?.photo ? `${urlProfile}${user.photo}` : defaultProfile}
              alt="Profil"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = defaultProfile;
              }}
            />
            <span className="fw-semibold small d-none d-md-inline">
              {user.nom} {user.prenom}
            </span>
          </button>

          <ul className="dropdown-menu dropdown-menu-end shadow-sm">
            <li>
              <Link className="dropdown-item" to="/profile">
                <i className="fa fa-user me-2 text-secondary"></i>Profil
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/setting">
                <i className="fa fa-cog me-2 text-secondary"></i>Paramètres
              </Link>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <button className="dropdown-item text-danger" onClick={logout}>
                <i className="fa fa-sign-out me-2"></i>Déconnexion
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Topbar;